import { useState } from 'react';
import { useGetApartmentsMutation } from '@services/member/apartment/apartment.endpoints';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BookingTable } from '@services/member/booking/booking.types';

export const useDetailsBookingsVM = () => {
    const { id } = useParams();
    const [selectedBooking, setSelectedBooking] = useState<BookingTable | null>(null);

    const [
        getApartments,
        {
            isLoading: isGetApartmentsLoading,
            isUninitialized: isGetApartmentsUninitialized,
            isError: isGetApartmentsError
        }
    ] = useGetApartmentsMutation();

    useEffect(() => {
        if (!id) return;
        getApartments({});
    }, [id]);

    const handleBookingSelect = (booking: BookingTable) => {
        setSelectedBooking(booking);
    };

    return {
        isLoading: isGetApartmentsUninitialized || isGetApartmentsLoading,
        isError: isGetApartmentsError,
        selectedBooking,
        handleBookingSelect
    };
};
